import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import Button from '../components/Button';
import '../components/Layout.css';

export default function CoachReviewActionPage() {
  const [searchParams] = useSearchParams();
  const { API_URL } = useAuth();

  // 'loading' | 'confirm' | 'processing' | 'success' | 'error'
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const [info, setInfo] = useState(null); // { action, coach_name, coach_email, already_processed }

  const token = searchParams.get('token');

  // On load: fetch info only — do NOT execute the action
  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('No review token found in this link.');
      return;
    }

    axios.get(`${API_URL}/admin/coach-review/info?token=${encodeURIComponent(token)}`)
      .then((res) => {
        setInfo(res.data);
        if (res.data.already_processed) {
          setStatus('error');
          setMessage('This coach application has already been processed.');
        } else {
          setStatus('confirm');
        }
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.detail || 'This link is invalid or has expired.');
      });
  }, [token, API_URL]);

  const handleConfirm = () => {
    setStatus('processing');
    axios.post(`${API_URL}/admin/coach-review/action?token=${encodeURIComponent(token)}`)
      .then((res) => {
        setStatus('success');
        setMessage(res.data.message || 'Action completed successfully.');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.detail || 'This link is invalid or has already been used.');
      });
  };

  const isApprove = info?.action === 'approve';
  const actionLabel = isApprove ? 'Approve' : 'Deny';
  const actionColor = isApprove ? '#16a34a' : '#dc2626';

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f1f5f9' }}>
      <div className="card" style={{ maxWidth: '440px', width: '100%', margin: '0 20px', textAlign: 'center', padding: '40px 32px' }}>
        <div style={{ fontSize: '28px', fontWeight: 700, color: '#0066cc', marginBottom: '24px' }}>ProZpects</div>

        {status === 'loading' && (
          <p style={{ color: '#64748b', fontSize: '15px' }}>Loading...</p>
        )}

        {status === 'confirm' && info && (
          <>
            <div style={{ fontSize: '40px', marginBottom: '12px' }}>{isApprove ? '✓' : '✕'}</div>
            <h2 style={{ fontSize: '20px', fontWeight: 700, color: '#1a202c', marginBottom: '8px' }}>
              {actionLabel} Coach Application
            </h2>
            <p style={{ color: '#64748b', fontSize: '14px', marginBottom: '4px' }}>{info.coach_name}</p>
            <p style={{ color: '#94a3b8', fontSize: '13px', marginBottom: '24px' }}>{info.coach_email}</p>
            <p style={{ color: '#475569', fontSize: '14px', marginBottom: '24px' }}>
              {isApprove
                ? 'This will grant the coach full access to the ProZpects platform.'
                : 'This will deny the coach application and set their account to base user.'}
            </p>
            <Button
              variant={isApprove ? 'primary' : 'secondary'}
              fullWidth
              style={{ marginBottom: '12px' }}
              onClick={handleConfirm}
            >
              Confirm {actionLabel}
            </Button>
            <Link to="/admin/users" style={{ color: '#64748b', fontSize: '14px', textDecoration: 'none' }}>
              Cancel — Go to User Management
            </Link>
          </>
        )}

        {status === 'processing' && (
          <p style={{ color: '#64748b', fontSize: '15px' }}>Processing...</p>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>✓</div>
            <h2 style={{ fontSize: '20px', fontWeight: 700, color: '#16a34a', marginBottom: '12px' }}>Done</h2>
            <p style={{ color: '#1a202c', fontSize: '15px', marginBottom: '24px' }}>{message}</p>
            <Button to="/admin/users" variant="accent">
              Go to User Management
            </Button>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>✕</div>
            <h2 style={{ fontSize: '20px', fontWeight: 700, color: '#dc2626', marginBottom: '12px' }}>Unable to Process</h2>
            <p style={{ color: '#1a202c', fontSize: '15px', marginBottom: '24px' }}>{message}</p>
            <Button to="/admin/users" variant="secondary">
              Go to User Management
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
